export const ROUTES: Record<string, string> = {
  ROOT: '/',
  INVALID: '/error/invalid-schedule-link',
  MAINTENANCE: '/maintenance',
  PRIVACY_POLICY: '/legal/privacy-policy',
  TERMS_OF_SERVICE: '/legal/terms-of-service',
  SCHEDULE: '/schedule/:id',
  SHARE: '/s/:id',
  SHARE_DIRECT: '/:id',
  APPOINTMENT: '/view/:id',
  HELP: '/support/help',
  DELETE_ACCOUNT: '/support/delete-account',
  ANDROID: '/download/android',
  IOS: '/download/ios',
  DEMO: '/s/demo',
  CLUB: '/social/club',
  GROUP: '/g/:id'
};

export const LEGACY_ROUTES: Record<string, string> = {
  INVALID: '/invalid',
  HELP: '/help',
  DELETE_ACCOUNT: '/delete-account',
  ANDROID: '/android',
  IOS: '/ios',
  CLUB: '/club',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service'
};

export const getScheduleRoute = (id: string | null | undefined) =>
  id ? ROUTES.SCHEDULE.replace(':id', id) : ROUTES.INVALID;

export const getShareRoute = (id: string | null | undefined) =>
  id ? ROUTES.SHARE.replace(':id', id) : ROUTES.INVALID;

export const getAppointmentRoute = (id: string | null | undefined) =>
  id ? ROUTES.APPOINTMENT.replace(':id', id) : ROUTES.INVALID;
